var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"application"},[_c('Preloader'),_vm._v(" "),_c('flash-message',{attrs:{"outerClass":'notifications'}}),_vm._v(" "),_c('router-view',{key:_vm.$route.fullPath})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }